<div class="search-main-div">
  <div class="searchbox-placement">
    <!-- New serach feature starts-->
    <div>
      <input
        (focus)="searchValue.length > 0 ? (showApplicationList = true) : (showApplicationList = false)"
        type="text"
        class="search-option table-data-font search-box"
        (keyup)="inputSearchAppListPopup($event); searchApplication($event)"
        (blur)="inputSearchAppListPopup($event)"
        (keydown)="$event.stopPropagation()"
        [(ngModel)]="searchValue"
        placeholder="Search by Application ID or Application Name or Alias"
      />
      <img class="search_Icon" src="../../../../assets/images/searchicon.png" style="position: relative;" />
      @if (showApplicationList) {
      <div [@openClose]="showApplicationList" id="menu" class="list-container">
        <div class="scroll-app-list">
          <div
            style="margin: 1% 2%; display: flex;
                  justify-content: space-between;"
          >
            <span class="search-list-header"
              >{{ totalSearchedApp >= 20 ? 'Top' : '' }} {{ totalSearchedApp }} Results Found</span
            >
            <mat-icon (click)="showApplicationList = false" class="close-icon">close</mat-icon>
          </div>
          <ul class="list-group">
            @if (showAppListLoader) { @for (i of [1,2,3,4,5]; track i) {
            <button class="list-group-item list-item">
              <mat-progress-bar mode="buffer" class="dark-blue"></mat-progress-bar>
            </button>
            } } @else { @for (name of appNameList; track name) {
            <button class="list-group-item list-item" (click)="searchSpecificApplication(name)">
              <strong>{{ name.app_id }}</strong
              >&nbsp;&nbsp; {{ name.app_name }}
            </button>
            } }
          </ul>
        </div>
        <button class="list-group-item list-item list-footer viewAll" (click)="viewAllClick()">
          View all {{ appSearchTotalCount }} results
        </button>
      </div>
      }
    </div>
  </div>
</div>
